<template>
  <div>
    <div v-if="isCenter">
      <div>
        <div v-for="itemList in commodityList" style="text-align: center;width: 100%;">
          <div style="width: 1000px;margin: 0 auto;">
            <el-row type="flex" justify="start">
              <div v-for="item in itemList">
                <el-card
                  shadow="hover"
                  style="width: 240px;background-color: #ECECEC;margin: 10px;"
                  :body-style="{ padding: '0px', height:'300px'}"
                >
                  <div @click="getComodity(item.productId)">
                    <div>
                      <img
                        class="commodityImg"
                        style="width: 240px;height: 240px;"
                        :src="transformTo480(item.image)"
                        onerror="this.src='http://dfs.uarm.lbslm.com/file/cloud/photo/e5799b96340449c49af2409511223e52.jpg';this.onerror=null"
                      />
                    </div>
                    <div class="nameDiv">
                      <span>{{item.name}}</span>
                    </div>
                  </div>
                </el-card>
              </div>
            </el-row>
          </div>
        </div>
      </div>
      <el-pagination
        background
        style="text-align:center;margin-top: 35px;margin-bottom: 55px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[8, 16, 64, 128]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <div v-if="!isCenter">
      <el-container>
        <el-aside width="720px">
          <div style="margin-top: 20px;">
            <i class="el-icon-back" style="font-size: 16px;cursor:pointer;" @click="goback">返回</i>
          </div>
          <div style="margin-top: 20px;">
            <div style="width: 695px;margin-left: 15px;" class="messageDiv">
              <el-container>
                <el-aside width="330px">
                  <div class="imageCarousel">
                    <el-carousel indicator-position="outside">
                      <el-carousel-item
                        v-for="item in mainImage"
                        :key="item"
                        style="text-align:center"
                      >
                        <img
                          :src="item"
                          style="width:auto;height: auto;max-width: 100%;max-height: 100%;"
                        />
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                </el-aside>
                <el-main style="padding: 0;padding-left:20px">
                  <div style="width: 320px;">
                    <div>
                      <h3>{{name}}</h3>
                      <hr class="hrClass" />
                    </div>
                    <div class="divClass">
                      <el-row :gutter="20" v-for="item in othersPropsList">
                        <el-col :span="8">
                          <span>{{item.pname}}</span>
                        </el-col>
                        <el-col :span="16">
                          <span v-for="item1 in item.vlist">{{item1.vname}}</span>
                        </el-col>
                      </el-row>
                    </div>
                    <div class="divClass">
                      <el-row :gutter="20">
                        <el-col :span="8">
                          <span>价格</span>
                        </el-col>
                        <el-col :span="16">
                          <span>{{price}}元</span>
                        </el-col>
                      </el-row>
                    </div>
                    <div>
                      <el-row :gutter="20" v-for="item in salePropsList" class="divClass">
                        <el-col :span="8">
                          <span>{{item.pname}}</span>
                        </el-col>
                        <el-col :span="16">
                          <button
                            v-for="item1 in item.vlist"
                            @click="selectType(item.pid,item1.vid)"
                            :id="item1.vid"
                            class="saleClass"
                          >{{item1.vname}}</button>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20" class="divClass" v-if="salePropsList.length <= 0">
                        <el-col :span="8">
                          <span>类型</span>
                        </el-col>
                        <el-col :span="16">
                          <span style="padding: 5px;background-color: black;color: white;">默认</span>
                        </el-col>
                      </el-row>
                    </div>
                    <div>
                      <el-row :gutter="20" class="divClass">
                        <el-col :span="8">
                          <span style="line-height: 36px;">购买数量</span>
                        </el-col>
                        <el-col :span="16">
                          <el-input
                            style="width: 120px;"
                            v-model="buyCount"
                            placeholder="请输入购买数"
                            oninput="value=value.replace(/[^\d]/g,'')"
                          />
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </el-main>
              </el-container>
            </div>
          </div>
        </el-aside>
        <el-main>
          <div style="border-left: 1px solid #0099FB;min-height: 100%;">
            <div style="padding: 8px;">
              <div>
                <strong>地址</strong>
                <i class="el-icon-plus" style="margin-left: 10px;cursor:pointer;font-size: 12px;">
                  <span @click="openDialog">新增地址</span>
                </i>
              </div>
              <div style="margin-top: 10px;">
                <div v-if="addressList  &&  addressList.length > 0">
                  <el-select v-model="addressId">
                    <el-option
                      :value="item.addressId"
                      :label="item.location"
                      style="height: 40px;font-size: 11px;"
                      v-for="item in addressList"
                    >
                      <el-row style="height: 20px;">
                        <el-col :span="8" style="line-height: 20px;height: 20px;">{{item.consignee}}</el-col>
                        <el-col :span="16" style="line-height: 20px;height: 20px;">{{item.phone}}</el-col>
                      </el-row>
                      <el-row style="height: 20px;font-size: 10px;">
                        <el-col :span="24" style="line-height: 20px;height: 20px;">{{item.location}}</el-col>
                      </el-row>
                    </el-option>
                  </el-select>
                </div>
                <div v-else>暂无最新地址</div>
              </div>
              <div style="margin-top: 20px;">
                <strong>商品及其数量</strong>
              </div>
              <div style="margin-top: 10px;font-size: 14px;">
                <div style="border: 1px solid #dcd8d8;padding: 10px;">
                  <div>
                    <strong>{{name}}</strong>
                  </div>
                  <div style="margin-top: 15px;">
                    <table>
                      <tr>
                        <td>数量:</td>
                        <td>{{buyCount}}</td>
                      </tr>
                      <tr>
                        <td>规格:</td>
                        <td>{{propertiesName}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <div style="margin-top: 20px;">
                <strong>
                  合计:
                  <span style="color: orange;">{{totalMoney}}</span>
                </strong>
              </div>
              <div style="margin-top: 20px;">
                <el-button type="warning" @click="createOrder">购买</el-button>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </div>
    <el-dialog title="添加地址" :visible.sync="myDialog">
      <div>
        <div>
          <span>收件人</span>
          <el-input type="text" v-model="consignee" style="width: 217px;margin-left: 50px;"></el-input>
        </div>
        <div style="margin-top: 15px;">
          <span>手机号</span>
          <el-input type="text" v-model="phone" style="width: 217px;margin-left: 50px;"></el-input>
        </div>
        <div style="margin-top: 15px;">
          <span>收件地址</span>
          <el-input type="text" v-model="address" style="width: 217px;margin-left: 36px;"></el-input>
        </div>
        <div style="margin-top: 25px;margin-left: 92px;">
          <el-button type="primary" @click="newAddress">新增地址</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'commodityCenter',
  components: {
  },
  data () {
    return {
      commodityList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      isCenter: true,
      productId: '',
      name: "",
      skuId: "",
      mainImage: [],
      minPrice: 0,
      maxPrice: 0,
      hasSkuProps: true,
      skuProductList: [],
      salePropsList: [],
      othersPropsList: [],
      buyCount: 1,
      saleList: [],
      message: "购买",
      addressList: [],
      addressId: '0',
      propertiesName: '',
      totalMoney: 0,
      myDialog: false,
      phone: '',
      consignee: '',
      address: ''
    }
  },
  watch: {
  },
  computed: {
    hasCount: function () {
      var getResult = true;
      var skuStr = "";
      for (var i = 0; i < this.saleList.length; i++) {
        skuStr += this.saleList[i].pid + ":" + this.saleList[i].value + ";";
        if (this.saleList[i].value == "") {
          getResult = false;
        }
      }
      if (getResult) {
        for (var i = 0; i < this.skuProductList.length; i++) {
          if (skuStr.substring(0, skuStr.length - 1) == this.skuProductList[i].properties) {
            this.skuId = this.skuProductList[i].skuId;
            this.propertiesName = this.skuProductList[i].propertiesName;
            this.totalMoney = this.skuProductList[i].price * this.buyCount;
            return this.skuProductList[i].quantity;
          }
        }
      }
      return 0;
    },
    price: function () {
      var getResult = true;
      var skuStr = "";
      for (var i = 0; i < this.saleList.length; i++) {
        skuStr += this.saleList[i].pid + ":" + this.saleList[i].value + ";";
        if (this.saleList[i].value == "") {
          getResult = false;
        }
      }
      if (getResult) {
        for (var i = 0; i < this.skuProductList.length; i++) {
          if (skuStr.substring(0, skuStr.length - 1) == this.skuProductList[i].properties) {
            this.skuId = this.skuProductList[i].skuId;
            this.propertiesName = this.skuProductList[i].propertiesName;
            this.totalMoney = this.skuProductList[i].price * this.buyCount;
            return this.skuProductList[i].price;
          }
        }
      }
      return this.minPrice + "~" + this.maxPrice;
    }
  },
  mounted () {
    this.updateTable();
  },
  beforeDestroy () {
  },
  methods: {
    getComodity (val) {
      let newPage = this.$router.resolve({
        name: 'commodityDetail',
        query: {
          productId: val
        }
      });
      // window.open(newPage.href, '_blank');
      this.isCenter = false
      this.productId = val;
      if (this.productId != "" && this.productId != null) {
        this.initPage(this.productId);
      } else {
        this.$message.error("获取商品失败，请刷新界面!");
      }
    },
    handleSizeChange (val) {
      this.pageSize = val;
      this.updateTable();
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      this.updateTable();
    },
    updateTable () {
      var thiz = this;
      thiz.commodityList = [];
      const loading = this.$loading({
        lock: true,
        text: '获取表格数据中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        loading.close();
      }, 3000);
      axios.get(this.$store.getters.getApiValue + '/product/listForHomeCustomer.do', {
        params: {
          pageId: thiz.currentPage,
          size: thiz.pageSize
        }
      }).then(function (response) {
        loading.close();
        var data = response.data;
        if (data.status == "200") {
          var list = data.data;
          var itemList = [];
          for (var i = 0; i < list.length; i++) {
            itemList.push(list[i]);
            if (itemList.length >= 4) {
              thiz.commodityList.push(itemList);
              itemList = [];
            }
          }
          thiz.commodityList.push(itemList);
          thiz.total = data.totalCount;
        } else {
          thiz.$message.error(data.message);
        }
      }).catch(function (error) {
        loading.close();
        thiz.$message.error("系统异常，请与管理员联系!");
        console.log(error);
      });
    },
    goback () {
      this.saleList = [];
      this.isCenter = true;
      this.buyCount = 1;
      this.totalMoney = 0;
    },
    initPage (val) {
      var thiz = this;
      axios.get(this.$store.getters.getApiValue + '/product/getForHomeCustomer.do', {
        params: {
          productId: val
        }
      }).then(function (response) {
        var data = response.data;
        if (data.status == "200") {
          var commodity = data.data;
          thiz.mainImage = commodity.mainImage;
          thiz.name = commodity.name;
          thiz.othersPropsList = commodity.othersPropsList;
          thiz.salePropsList = commodity.salePropsList;
          thiz.getSaleList(commodity.salePropsList);
          thiz.skuProductList = commodity.skuProductList;
          if (thiz.skuProductList.length > 0) {
            thiz.minPrice = thiz.skuProductList[0].price;
            thiz.maxPrice = thiz.skuProductList[0].price;
          }
          for (var i = 1; i < thiz.skuProductList.length; i++) {
            if (thiz.skuProductList[i].price < thiz.minPrice) {
              thiz.minPrice = thiz.skuProductList[i].price;
            }
            if (thiz.skuProductList[i].price > thiz.maxPrice) {
              thiz.maxPrice = thiz.skuProductList[i].price;
            }
          }
          axios.get(thiz.$store.getters.getApiValue + '/srsAddress/getAddressList.do')
            .then(function (res) {
              var data1 = res.data;
              if (data1.status == "200") {
                thiz.addressList = data1.data;
                thiz.isCenter = false;
              } else {
                thiz.$message.error("获取用户地址失败!请刷新页面!");
              }
            }).catch(function (error) {
              thiz.$message.error("系统异常,请与管理员联系!");
            });
        } else {
          thiz.$message.error("获取商品失败!请刷新页面!");
        }
      }).catch(function (error) {
        console.log(error)
        thiz.$message.error("系统异常,请与管理员联系!xxx");
      });
    },
    getSaleList (list) {
      for (var i = 0; i < list.length; i++) {
        var item = {
          pid: list[i].pid,
          value: ''
        }
        this.saleList.push(item);
      }
    },
    selectType (pid, vid) {
      for (var i = 0; i < this.saleList.length; i++) {
        if (this.saleList[i].pid == pid) {
          if (this.saleList[i].value == vid) {
            this.changeButton(this.saleList[i].value, "", 0);
            this.saleList[i].value = "";
          } else {
            this.changeButton(this.saleList[i].value, vid, 1);
            this.saleList[i].value = vid;
          }
          break;
        }
      }
    },
    changeButton (oldVid, newVid, method) {
      if (oldVid != "") {
        document.getElementById(oldVid).style.backgroundColor = "white";
        document.getElementById(oldVid).style.color = "black";
      }
      if (method === 1) {
        document.getElementById(newVid).style.backgroundColor = "#ff5900";
        document.getElementById(newVid).style.color = "white";
      }
    },
    newAddress () {
      var thiz = this;
      axios.get(this.$store.getters.getApiValue + '/srsAddress/addAddress.do', {
        params: {
          consignee: this.consignee,
          location: this.address,
          phone: this.phone
        }
      }).then(function (response) {
        var data = response.data;
        if (data.status == "200") {
          if (data.data) {
            thiz.updateAddress();
          } else {
            thiz.$message.error("新增用户地址失败!请刷新页面!");
          }
        } else {
          thiz.$message.error(data.message);
        }
      }).catch(function (error) {
        thiz.$message.error("系统异常,请与管理员联系!");
      });
    },
    updateAddress () {
      var thiz = this;
      axios.get(this.$store.getters.getApiValue + '/srsAddress/getAddressList.do')
        .then(function (response) {
          var data1 = response.data;
          if (data1.status == "200") {
            thiz.addressList = data1.data;
            thiz.myDialog = false;
          } else {
            thiz.$message.error(data.message);
          }
        }).catch(function (error) {
          thiz.$message.error("系统异常,请与管理员联系!");
        });
    },
    openDialog () {
      this.consignee = "";
      this.address = "";
      this.phone = "";
      this.myDialog = true;
    },
    createOrder () {
      var thiz = this;
      if (this.addressId == '0') {
        thiz.$message.error("请选择收货地址!");
        return;
      }
      this.$confirm('本次需要在货款中支付 ' + this.totalMoney + ' 元，是否继续购买?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        const sku = this.skuProductList.filter(s => { return s.skuId === this.skuId })
        // 提交拼接
        const others = this.othersPropsList.map(p => {
          const vlist = p.vlist.map(p1 => {
            return p1.vname
          }).join(' ')
          return `${p.pname}:${vlist}`
        }).join(';')
        let propertiesName
        if (sku.length > 0 && sku[0].propertiesName !== '') {
          propertiesName = `${others};${sku[0].propertiesName}`
        } else {
          propertiesName = `${others}`
        }
        console.log(propertiesName)
        axios.get(this.$store.getters.getApiValue + '/order/create.do', {
          params: {
            addressId: this.addressId,
            quantity: this.buyCount,
            skuId: this.skuId,
            image: this.mainImage[0],
            propertiesName
          }
        }).then(function (response) {
          var data = response.data;
          if (data.status == "200") {
            if (data.data) {
              thiz.$message.success("商品购买并支付成功, 请在订单中心查看详情");
            } else {
              thiz.$message.error("购买失败!请刷新页面!");
            }
          } else {
            thiz.$message.error(data.message);
          }
        }).catch(function (error) {
          thiz.$message.error("系统异常,请与管理员联系!");
        });

      }).catch(() => {
        return false;
      });



    },
    transformTo480 (img) {
      var i = img.lastIndexOf('.');
      // const imgUrl = img.split('_')
      // console.log(imgUrl)
      return img.substring(0, i) + '_480x480.jpg';
    }
  }
}
</script>

<style>
.commodityDiv {
  float: left;
  width: 200px;
  margin: 10px;
}
.commodityImg {
  width: 240px;
  height: 240px;
}
.nameDiv {
  padding-top: 15px;
  padding-bottom: 15px;
  width: 100%;
  text-align: center;
}
.imageCarousel .el-carousel {
  width: 320px;
  height: 380px;
}
.imageCarousel .el-carousel__container {
  width: 320px;
  height: 320px;
}
.imageCarousel .el-carousel__item {
  background-color: #fff;
  height: 320px;
  line-height: 320px;
}
.imageCarousel .el-carousel__item img {
  width: 320px;
  height: 320px;
  vertical-align: middle;
}
.messageDiv .el-main {
  padding: 0px;
}
.divClass {
  padding-top: 15px;
  padding-right: 50px;
}
.divClass span {
  line-height: 32px;
  font-size: 13px;
}
.saleClass {
  padding: 5px;
  margin-right: 5px;
  border: 1px solid #dcd8d8;
  background-color: white;
}
.hrClass {
  width: 100%;
  margin: 0 auto;
  border: 0;
  height: 1px;
  background: #fff;
  background-image: linear-gradient(to right, #adabab, #adabab, #fff);
}
</style>
